
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"111","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-only-logo-clip0_18360_110605)"}},[_c('path',{attrs:{"d":"M110.66 0H0v59.874h110.66V0z","fill":"#000"}}),_c('path',{attrs:{"d":"M77.456 26.559a5.592 5.592 0 00-1.433 3.705 5.47 5.47 0 005.465 5.464 5.47 5.47 0 004.685-8.278l-.171-.283.312.09c2.732.794 5.338 2.984 5.836 3.482l.059.06-.037.08c-1.797 4.1-5.784 6.542-10.655 6.542-4.893 0-8.954-2.54-11.13-6.972l-.022-.052.022-.052c1.753-4.655 6.482-7.781 11.776-7.781 3.987 0 8.19 1.389 11.279 3.72.311-1.151.356-2.198.356-2.465-.564-.379-5.339-3.445-11.642-3.445-7.707 0-12.712 5.182-14.1 10.008 1.582 4.596 6.34 9.222 13.439 9.222 7.039 0 11.805-4.603 13.424-9.184-3.297-3.609-8.07-5.762-12.778-5.762-1.945.007-3.571.66-4.685 1.9zm7.291 3.705a3.28 3.28 0 01-3.274 3.274 3.28 3.28 0 01-3.275-3.274 3.28 3.28 0 013.275-3.275 3.28 3.28 0 013.274 3.275z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.478 17.478h17.478v25.036H17.478V17.478zm14.954 2.524h-12.43v19.996h12.43V20.003z","fill":"#FFD800"}}),_c('path',{attrs:{"d":"M53.117 17.478h-.638v25.044h.638V17.478z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-only-logo-clip0_18360_110605"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h110.452v60H0z"}})])])])
          )
        }
      }
    